import {
  type GraphSharedViewParameters,
  isCompareGraphOverlay,
} from '@ipfabric/utils';
import type { Snapshot } from 'pages/SnapshotManagement/snapshotManagementTypes';

export const areSharedViewSnapshotsLoaded = (
  parameters: GraphSharedViewParameters,
  snapshots: Snapshot[],
): boolean => {
  const overlay = parameters.viewUrlData?.graphView?.overlay;

  const missingMainSnapshot =
    parameters.viewUrlData &&
    !snapshots.some(({ id }) => parameters.viewUrlData?.snapshot === id);
  const missingCompareSnapshot = isCompareGraphOverlay(overlay)
    ? !snapshots.some(({ id }) => overlay?.snapshotToCompare === id)
    : false;

  return !missingMainSnapshot && !missingCompareSnapshot;
};
